import block_icon from '../icons/counter'
import color_palette_list from '../gb-helper/color_palette';
import { all_font_families } from '../gb-helper/font_family_detailed';
import { useEffect } from 'react';


const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls, RichText } = wp.blockEditor;
const { PanelBody, PanelRow, SelectControl, Dashicon, Card, CardBody, Button, TextControl,
    RangeControl, ColorIndicator, ColorPalette, ToggleControl } = wp.components;

registerBlockType('blocksbakery/counter', {
    title: __('Counter', 'blocks-bakery'),
    description: __(
        'Counter Button Dscription .',
        'blocks-bakery'
    ),
    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: block_icon.counter_icon,
    keywords: [
        __('Counter', 'blocks-bakery'),
        __('Count Up', 'blocks-bakery'),
        __('Count', 'blocks-bakery')
    ],
    supports: {
        html: false,
    },
    "attributes": {
        "count_start": {
            "type": "number",
            "default": 1
        },
        "count_end": {
            "type": "number",
            "default": 100
        },
        "count_animation_duration": {
            "type": "number",
            "default": 5000
        },
        "count_seperator_toggle": {
            "type": "boolean",
            "default": false
        },
        "seperator_display": {
            "type": "string",
            "default": "none"
        },
        "count_seperator": {
            "type": "string",
            "default": ""
        },
        "counter_color": {
            "type": "string",
            "default": "#6EC1E4"
        },
        "counter_opacity": {
            "type": "string",
            "default": "FF"
        },
        "counter_family": {
            "type": "string",
            "default": "Roboto"
        },
        "counter_weight": {
            "type": "string",
            "default": "600"
        },
        "text_transform": {
            "type": "html",
            "default": "none",
        },
        "counter_decoration": {
            "type": "string",
            "default": "none",
        },
        "counter_height": {
            "type": "number",
            "default": 1.5
        },
        "counter_size": {
            "type": "number",
            "default": 40
        },
        "counter_font_unit": {
            "type": "string",
            "default": "px"
        },
        "blend_mode": {
            "type": "string",
            "default": "normal"
        },
        "counter_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "title_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "counter_lh_unit": {
            "type": "string",
            "default": "em"
        },
        "letter_spacing_counter": {
            "type": "number",
            "default":0
        },
        "counter_shadow_horizontal": {
            "type": "number",
            "default": 0
        },
        "counter_shadow_vertical": {
            "type": "number",
            "default": 0
        },
        "counter_shadow_blur": {
            "type": "number",
            "default": 10
        },
        "counter_shadow_color": {
            "type": "string",
            "default":''
        },
        "counter_align": {
            "type": "string",
            "default": "center"
        },
        "font_style": {
            "type": "string",
            "default": "inherit"
        },
        "font_range_controller": {
            "type": "number",
            "default": 200
        },
        "line_range_controller": {
            "type": "number",
            "default": 100
        },

        // title attributes

        "counter_title_color": {
            "type": "string",
            "default": "#000000"
        },
        "counter_title_opacity": {
            "type": "string",
            "default": "FF"
        },
        "counter_title_family": {
            "type": "string",
            "default": "Arial"
        },
        "counter_title_weight": {
            "type": "string",
            "default": "regular"
        },
        "text_title_transform": {
            "type": "html",
            "default": "none",
        },
        "counter_title_decoration": {
            "type": "string",
            "default": "none",
        },
        "counter_title_height": {
            "type": "number",
            "default": 1.5,
        },
        "counter_title_size": {
            "type": "number",
        },
        "counter_title_font_unit": {
            "type": "string",
            "default": "px"
        },
        "title_blend_mode": {
            "type": "string",
            "default": "normal"
        },
        "counter_title_style": {
            "source": "attribute",
            "attribute": "style"
        },

        "counter_title_lh_unit": {
            "type": "string",
            "default": "em"
        },
        "title_letter_spacing_counter": {
            "type": "number",
            "default":''
        },
        "counter_title_shadow_horizontal": {
            "type": "number",
            "default": 0
        },
        "counter_title_shadow_vertical": {
            "type": "number",
            "default": 0
        },
        "counter_title_shadow_blur": {
            "type": "number",
            "default": 10
        },
        "counter_title_shadow_color": {
            "type": "string",
            "default":''
        },
        "counter_title_align": {
            "type": "string",
            "default": "center"
        },
        "title_font_style": {
            "type": "string",
            "default": "inherit"
        },
        "title_font_range_controller": {
            "type": "number",
            "default": 200
        },
        "title_line_range_controller": {
            "type": "number",
            "default": 100
        },
        "count_prefix": {
            "type": "string",
            "default": ""
        },
        "count_suffix": {
            "type": "string",
            "default": ""
        },
        "count_title": {
            "type": "string",
            "default": ''
        }
    },


    edit: (props) => {
        useEffect(() => {
            var duration = props.attributes.count_animation_duration
            jQuery('.counter').each(function () {
                var $this = jQuery(this);
                jQuery({ Counter: $this.attr('data-counter-start') }).animate({ Counter: $this.attr('data-counter-end') }, {
                    duration: duration,
                    easing: 'swing',
                    step: function (now) {
                        $this.text(numberWithCommas(Math.round(now)));
                    },
                });
                function numberWithCommas(x) {
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, props.attributes.count_seperator);
                }
            });
        })

        // Color Converter
        const hexConverter = (val) => {
            val = Math.round(val * 100) / 100;
            var alpha = Math.round(val * 255);
            var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
            props.setAttributes({ counter_opacity: hex })
        }
        const hexTitleConverter = (val) => {
            val = Math.round(val * 100) / 100;
            var alpha = Math.round(val * 255);
            var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
            props.setAttributes({ counter_title_opacity: hex })
        }

        // Property Unit Change
        var px_case = document.getElementById("px_case");
        var em_case = document.getElementById("em_case");
        var rem_case = document.getElementById("rem_case");
        var vw_case = document.getElementById("vw_case");
        const pxCase = () => {
            px_case.style.textDecoration = "underline";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";
            props.setAttributes({ counter_font_unit: 'px', font_range_controller: 200 })
            console.log("px")
        }
        const emCase = () => {
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "underline";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";
            props.setAttributes({ font_range_controller: 10, counter_font_unit: 'em'})
            console.log("em")
        }
        const remCase = () => {
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "underline";
            vw_case.style.textDecoration = "none";
            props.setAttributes({ counter_font_unit: 'rem', font_range_controller: 10 })
        }
        const vwCase = () => {
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "underline";
            props.setAttributes({ counter_font_unit: 'vw', font_range_controller: 10 })
        }


        var px_title_case = document.getElementById("px_title_case");
        var em_title_case = document.getElementById("em_title_case");
        var rem_title_case = document.getElementById("rem_title_case");
        var vw_title_case = document.getElementById("vw_title_case");
        const pxTitleCase = () => {
            px_title_case.style.textDecoration = "underline";
            em_title_case.style.textDecoration = "none";
            rem_title_case.style.textDecoration = "none";
            vw_title_case.style.textDecoration = "none";
            props.setAttributes({ counter_title_font_unit: 'px', title_font_range_controller: 200 })
            console.log("px")
        }
        const emTitleCase = () => {
            px_title_case.style.textDecoration = "none";
            em_title_case.style.textDecoration = "underline";
            rem_title_case.style.textDecoration = "none";
            vw_title_case.style.textDecoration = "none";
            props.setAttributes({ counter_title_font_unit: 'em', title_font_range_controller: 10 })
            console.log("em")
        }
        const remTitleCase = () => {
            px_title_case.style.textDecoration = "none";
            em_title_case.style.textDecoration = "none";
            rem_title_case.style.textDecoration = "underline";
            vw_title_case.style.textDecoration = "none";
            props.setAttributes({ counter_title_font_unit: 'rem', title_font_range_controller: 10 })
        }
        const vwTitleCase = () => {
            px_title_case.style.textDecoration = "none";
            em_title_case.style.textDecoration = "none";
            rem_title_case.style.textDecoration = "none";
            vw_title_case.style.textDecoration = "underline";
            props.setAttributes({ counter_title_font_unit: 'vw', title_font_range_controller: 10 })
        }

        var counter_px_lineh = document.getElementById("counter_px_lineh");
        var counter_em_lineh = document.getElementById("counter_em_lineh");
        const counterPxLh = () => {
            counter_px_lineh.style.textDecoration = "underline";
            counter_em_lineh.style.textDecoration = "none";
            props.setAttributes({ counter_lh_unit: 'px', line_range_controller: 100 })
        }
        const counterEmLh = () => {
            counter_px_lineh.style.textDecoration = "none";
            counter_em_lineh.style.textDecoration = "underline";
            props.setAttributes({ counter_lh_unit: 'em', line_range_controller: 10 })
        }

        var title_px_lineh = document.getElementById("title_px_lineh");
        var title_em_lineh = document.getElementById("title_em_lineh");
        const titlePxLh = () => {
            title_px_lineh.style.textDecoration = "underline";
            title_em_lineh.style.textDecoration = "none";
            props.setAttributes({ counter_title_lh_unit: 'px', title_line_range_controller: 100 })
        }
        const titleEmLh = () => {
            title_px_lineh.style.textDecoration = "none";
            title_em_lineh.style.textDecoration = "underline";
            props.setAttributes({ counter_title_lh_unit: 'em', title_line_range_controller: 10 })
        }


        // Reset Functionality
        const counterReset = () => {
            props.setAttributes({ counter_shadow_horizontal: 0, counter_shadow_vertical: 0, counter_shadow_color: '', counter_shadow_blur: 0 })
        }
        const titleReset = () => {
            props.setAttributes({ counter_title_shadow_horizontal: 0, counter_title_shadow_vertical: 0, counter_title_shadow_color: '', counter_title_shadow_blur: 0 })
        }
        const clearCounterColor = () => {
            props.setAttributes({ counter_color: '#6EC1E4' })
        }
        const clearCounterShadowColor = () => {
            props.setAttributes({ counter_shadow_color: 'transparent' })
        }
        const clearTitleColor = () => {
            props.setAttributes({ counter_title_color: '#000000' })
        }
        const clearTitleShadowColor = () => {
            props.setAttributes({ counter_title_shadow_color: 'transparent', counter_title_shadow_blur: 10 })
        }

        // Toggle Controller
        const counterToggle = () => {
            props.setAttributes({ counter_shadow_color: "#000000", counter_shadow_blur: 10 })
            var x = document.getElementById("counter_toggle");
            if (x.style.display === "block") {
                x.style.display = "none"
            }
            else if (x.style.display === "none") {
                x.style.display = "block";
            }
        }

        const titleToggle = () => {
            props.setAttributes({ counter_title_shadow_color: "#000000" })
            var x = document.getElementById("title_toggle");
            if (x.style.display === "block") {
                x.style.display = "none"
            }
            else if (x.style.display === "none") {
                x.style.display = "block";
            }
        }

        let attributes = props.attributes;
        let setAttributes = props.setAttributes;
        let styles = {
            counter_style: {
                textDecoration: attributes.counter_decoration,
                color: attributes.counter_color + attributes.counter_opacity,
                fontFamily: attributes.counter_family,
                fontWeight: attributes.counter_weight,
                fontSize: attributes.counter_size + attributes.counter_font_unit,
                textTransform: attributes.text_transform,
                lineHeight: attributes.counter_height + attributes.counter_lh_unit,
                letterSpacing: attributes.letter_spacing_counter,
                textShadow: attributes.counter_shadow_horizontal + 'px ' + attributes.counter_shadow_vertical + 'px ' + attributes.counter_shadow_blur + 'px ' + attributes.counter_shadow_color,
                mixBlendMode: attributes.blend_mode,
                textAlign: attributes.counter_align,
                fontStyle: attributes.font_style
            },
            title_style: {
                textDecoration: attributes.counter_title_decoration,
                color: attributes.counter_title_color + attributes.counter_title_opacity,
                fontFamily: attributes.counter_title_family,
                fontWeight: attributes.counter_title_weight,
                fontSize: attributes.counter_title_size + attributes.counter_title_font_unit,
                textTransform: attributes.text_title_transform,
                lineHeight: attributes.counter_title_height + attributes.counter_title_lh_unit,
                letterSpacing: attributes.title_letter_spacing_counter,
                textShadow: attributes.counter_title_shadow_horizontal + 'px ' + attributes.counter_title_shadow_vertical + 'px ' + attributes.counter_title_shadow_blur + 'px ' + attributes.counter_title_shadow_color,
                mixBlendMode: attributes.title_blend_mode,
                textAlign: attributes.counter_title_align,
                fontStyle: attributes.title_font_style
            },
        }
        return (<React.Fragment >
            <InspectorControls>
                <PanelBody title={__('Content', 'blocks-bakery')} initialOpen={false}>
                    <TextControl
                        label={__("Starting Number")}
                        type="number"
                        help={__("Set Counter starting number.")}
                        value={attributes.count_start}
                        type="number"
                        onChange={(count_start) =>
                            setAttributes({ count_start: Number(count_start) })

                        }
                    />
                    <TextControl
                        label={__("Ending Number")}
                        help={__("Set Counter ending number.")}
                        type="number"
                        value={attributes.count_end}
                        onChange={(count_end) =>
                            setAttributes({ count_end: Number(count_end) })
                        }
                    />
                    <hr />
                    <TextControl
                        label="Number Prefix"
                        placeholder="1"
                        value={attributes.img_caption}
                        onChange={(value) => { setAttributes({ count_prefix: value }) }}
                    />

                    <hr />
                    <TextControl
                        label="Number Suffix"
                        placeholder="+"
                        value={attributes.img_caption}
                        onChange={(value) => { setAttributes({ count_suffix: value }) }}
                    />

                    <hr />

                    <TextControl
                        label={__("Animation Duration")}
                        help={__("Set Counter ending number.")}
                        type="number"
                        step={100}
                        value={attributes.count_animation_duration
                        }
                        onChange={(count_animation_duration) =>
                            setAttributes({ count_animation_duration: Number(count_animation_duration) })
                        }
                    />
                    <hr />

                    <ToggleControl
                        label="Thousand Seperator"
                        checked={attributes.count_seperator_toggle}
                        onChange={(val) => {
                            setAttributes({ count_seperator_toggle: val })
                            if (val === true) {
                                setAttributes({ seperator_display: "block", count_seperator: ',' })
                            } else {
                                setAttributes({ seperator_display: "none", count_seperator: '' })

                            }
                        }}
                    />


                    <SelectControl
                        style={{ display: attributes.seperator_display }}
                        label={__("Seperator", "blocks_bakery")}
                        value={attributes.count_seperator}
                        options={[
                            { label: 'Default', value: ',' },
                            { label: 'Dot', value: '.' },
                            { label: 'Seperator', value: ' ' },
                        ]}
                        onChange={(new_val) => {
                            setAttributes({ count_seperator: new_val })
                        }} />


                    <TextControl
                        label="Title"
                        placeholder="Cool Number"
                        value={attributes.count_title}
                        onChange={(value) => { setAttributes({ count_title: value }) }}
                    />


                </PanelBody>

                <PanelBody title={__('Number Color', 'blocks-bakery')} initialOpen={false}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <p> <span>Number Color</span>
                            <ColorIndicator
                                style={{ backgroundColor: attributes.counter_color }} />
                        </p>
                        <Dashicon icon="image-rotate" onClick={clearCounterColor} />
                    </div>
                    <ColorPalette
                        colors={color_palette_list}
                        clearable={false}
                        onChange={(new_val) => {
                            setAttributes({ counter_color: new_val })
                        }}
                        value={attributes.counter_color}
                    />
                    <RangeControl
                        label={__('Number Opacity', 'blocks-bakery')}
                        min={0}
                        max={1}
                        value={attributes.counter_opacity}
                        step={0.01}
                        onChange={(new_val) => {
                            setAttributes({ counter_opacity: new_val })
                            hexConverter(new_val)
                        }}
                    />
                    <SelectControl
                        label="Number Text Transform"
                        options={[
                            { label: 'Default', value: '' },
                            { label: 'Uppercase', value: 'uppercase' },
                            { label: 'Lowercase', value: 'lowercase' },
                            { label: 'Capitalize', value: 'capitalize' },
                            { label: 'Normal', value: 'normal' },
                        ]}
                        value={attributes.text_transform}
                        onChange={(new_val) => {
                            setAttributes({ text_transform: new_val })
                        }}
                    />
                    <hr />
                </PanelBody>
                <PanelBody title={__('Number Typography', 'blocks-bakery')} initialOpen={false}>
                    < SelectControl
                        label="Number Font Family"
                        options={all_font_families}
                        onChange={(new_val) => {
                            setAttributes({ counter_family: new_val })
                        }}
                        value={attributes.counter_family}
                    />
                    <SelectControl
                        label="Number Font Weight"
                        options={[
                            { label: '100', value: 100 },
                            { label: '200', value: 200 },
                            { label: '300', value: 300 },
                            { label: '400', value: 400 },
                            { label: '500', value: 500 },
                            { label: '600', value: 600 },
                            { label: '700', value: 700 },
                            { label: '800', value: 800 },
                            { label: '900', value: 900 },
                            { label: 'Default', value: '' },
                            { label: 'Normal', value: 'normal' },
                            { label: 'Bold', value: 'bold' }
                        ]
                        }
                        onChange={(new_val) => {
                            setAttributes({ counter_weight: new_val })
                        }}
                        value={attributes.counter_weight}
                    />

                    <SelectControl
                        label="Number Blend Mode"
                        options={[
                            { label: 'Normal', value: 'normal' },
                            { label: 'Multiply', value: 'multiply' },
                            { label: 'Screen', value: 'screen' },
                            { label: 'Overlay', value: 'overlay' },
                            { label: 'Darken', value: 'darken' },
                            { label: 'Lighten', value: 'lighten' },
                            { label: 'Color Dodge', value: 'color-dodge' },
                            { label: 'Color Burn', value: 'color-burn' },
                            { label: 'Hard Light', value: 'hard-light' },
                            { label: 'Soft Light', value: 'soft-light' },
                            { label: 'Difference', value: 'difference' },
                            { label: 'Exclusion', value: 'exclusion' },
                            { label: 'HUE', value: 'hue' },
                            { label: 'Saturation', value: 'saturation' },
                            { label: 'Color', value: 'color' },
                            { label: 'Luminosity', value: 'luminosity' },
                        ]}
                        value={attributes.blend_mode}
                        onChange={(new_val) => {
                            setAttributes({ blend_mode: new_val })
                        }}
                    />

                    <SelectControl
                        label="Number Decoration"
                        options={[
                            { label: 'Default', value: 'inherit' },
                            { label: 'Underline', value: 'underline' },
                            { label: 'line Through', value: 'line-through' },
                            { label: 'Line Trough and Underline', value: 'underline line-through' },
                            { label: 'overline', value: 'overline' },
                            { label: 'None', value: 'none' },

                        ]}
                        value={attributes.counter_decoration}
                        onChange={(new_val) => {
                            setAttributes({ counter_decoration: new_val })
                        }}
                    />
                    <SelectControl
                        label="Style"
                        options={[
                            { label: 'Default', value: 'none' },
                            { label: 'Normal', value: 'normal' },
                            { label: 'Italic', value: 'italic' },
                            { label: 'Oblique', value: 'oblique' },
                        ]}
                        value={attributes.font_style}
                        onChange={(new_val) => {
                            setAttributes({ font_style: new_val })
                        }}
                    />

                    <PanelRow>
                        <p>Typography</p>

                        <div>
                            <Button id="px_case" onClick={pxCase} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="em_case" onClick={emCase} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                            <Button id="rem_case" onClick={remCase} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>rem</Button>
                            <Button id="vw_case" onClick={vwCase} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vw</Button>
                        </div>
                    </PanelRow>
                    <RangeControl
                        label="Number Font Size"
                        min={0}
                        max={attributes.font_range_controller}
                        step={1}
                        initialPosition={26}
                        value={attributes.counter_size}
                        onChange={(new_val) => {
                            setAttributes({ counter_size: new_val })
                        }}
                    />
                    <PanelRow>
                        <p>Number Typography</p>

                        <div>
                            <Button id="counter_px_lineh" onClick={counterPxLh} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="counter_em_lineh" onClick={counterEmLh} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                        </div>
                    </PanelRow>
                    <RangeControl
                        label="Number Line Height "
                        min={0}
                        max={attributes.line_range_controller}
                        step={0.1}
                        initialPosition={1.5}
                        value={attributes.counter_height}
                        onChange={(new_val) => {
                            setAttributes({ counter_height: new_val })
                        }}
                    />
                    <RangeControl
                        label="Number Letter Spacing (px)"
                        min={0}
                        max={10}
                        step={0.1}
                        initialPosition={0}
                        value={attributes.letter_spacing_counter}
                        onChange={(new_val) => {
                            setAttributes({ letter_spacing_counter: new_val })
                        }}
                    />


                    <PanelRow>
                        <p>Number Text Shadow</p>
                        <div>
                            <Button onClick={counterReset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                            <Button onClick={counterToggle} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} /></span></Button>
                        </div>
                    </PanelRow>
                    <Card id="counter_toggle" style={{ display: "none" }}>
                        <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>

                            <RangeControl
                                label="Blur"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={10}
                                value={attributes.counter_shadow_blur}
                                onChange={(new_val) => {
                                    setAttributes({ counter_shadow_blur: new_val })
                                    console.log("Bur")
                                }}
                            />
                            <RangeControl
                                label="horizontal"
                                min={-100}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={attributes.counter_shadow_horizontal}
                                onChange={(new_val) => {
                                    setAttributes({ counter_shadow_horizontal: new_val })
                                    console.log("horitzental")
                                }}
                            />

                            <RangeControl
                                label="Vertical"
                                min={-100}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={attributes.counter_shadow_vertical}
                                onChange={(new_val) => {
                                    setAttributes({ counter_shadow_vertical: new_val })
                                    console.log("vertical")
                                }}
                            />

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <p> <span>Text Shadow Color</span>
                                    <ColorIndicator
                                        style={{ backgroundColor: attributes.counter_shadow_color }} />
                                </p>
                                <Dashicon icon="image-rotate" onClick={clearCounterShadowColor} />
                            </div>
                            <ColorPalette
                                clearable={false}
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    setAttributes({ counter_shadow_color: new_val })

                                }}
                                value={attributes.counter_shadow_color}
                            />
                        </CardBody>
                    </Card>

                </PanelBody>

                {/* Counter title Styliing */}

                <PanelBody title={__('Title Color', 'blocks-bakery')} initialOpen={false}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <p> <span>Text Color</span>
                            <ColorIndicator
                                style={{ backgroundColor: attributes.counter_title_color }} />
                        </p>
                        <Dashicon icon="image-rotate" onClick={clearTitleColor} />
                    </div>
                    <ColorPalette
                        colors={color_palette_list}
                        clearable={false}
                        onChange={(new_val) => {
                            setAttributes({ counter_title_color: new_val })
                        }}
                        value={attributes.counter_title_color}
                    />
                    <RangeControl
                        label={__('Opacity', 'blocks-bakery')}
                        min={0}
                        max={1}
                        value={attributes.counter_title_opacity}
                        step={0.01}
                        onChange={(new_val) => {
                            setAttributes({ counter_title_opacity: new_val })
                            hexTitleConverter(new_val)
                        }}
                    />
                    <SelectControl
                        label="Text Transform"
                        options={[
                            { label: 'Default', value: '' },
                            { label: 'Uppercase', value: 'uppercase' },
                            { label: 'Lowercase', value: 'lowercase' },
                            { label: 'Capitalize', value: 'capitalize' },
                            { label: 'Normal', value: 'normal' },
                        ]}
                        value={attributes.text_title_transform}
                        onChange={(new_val) => {
                            setAttributes({ text_title_transform: new_val })
                        }}
                    />
                    <hr />
                </PanelBody>
                <PanelBody title={__('Title Typography', 'blocks-bakery')} initialOpen={false}>
                    < SelectControl
                        label="Font Family"
                        options={all_font_families}
                        onChange={(new_val) => {
                            setAttributes({ counter_title_family: new_val })
                        }}
                        value={attributes.counter_title_family}
                    />
                    <SelectControl
                        label="Font Weight"
                        options={[
                            { label: '100', value: 100 },
                            { label: '200', value: 200 },
                            { label: '300', value: 300 },
                            { label: '400', value: 400 },
                            { label: '500', value: 500 },
                            { label: '600', value: 600 },
                            { label: '700', value: 700 },
                            { label: '800', value: 800 },
                            { label: '900', value: 900 },
                            { label: 'Default', value: '' },
                            { label: 'Normal', value: 'normal' },
                            { label: 'Bold', value: 'bold' }
                        ]
                        }
                        onChange={(new_val) => {
                            setAttributes({ counter_title_weight: new_val })
                        }}
                        value={attributes.counter_title_weight}
                    />

                    <SelectControl
                        label="Blend Mode"
                        options={[
                            { label: 'Normal', value: 'normal' },
                            { label: 'Multiply', value: 'multiply' },
                            { label: 'Screen', value: 'screen' },
                            { label: 'Overlay', value: 'overlay' },
                            { label: 'Darken', value: 'darken' },
                            { label: 'Lighten', value: 'lighten' },
                            { label: 'Color Dodge', value: 'color-dodge' },
                            { label: 'Color Burn', value: 'color-burn' },
                            { label: 'Hard Light', value: 'hard-light' },
                            { label: 'Soft Light', value: 'soft-light' },
                            { label: 'Difference', value: 'difference' },
                            { label: 'Exclusion', value: 'exclusion' },
                            { label: 'HUE', value: 'hue' },
                            { label: 'Saturation', value: 'saturation' },
                            { label: 'Color', value: 'color' },
                            { label: 'Luminosity', value: 'luminosity' },
                        ]}
                        value={attributes.title_blend_mode}
                        onChange={(new_val) => {
                            setAttributes({ title_blend_mode: new_val })
                        }}
                    />

                    <SelectControl
                        label="Decoration"
                        options={[
                            { label: 'Default', value: 'inherit' },
                            { label: 'Underline', value: 'underline' },
                            { label: 'line Through', value: 'line-through' },
                            { label: 'Line Trough and Underline', value: 'underline line-through' },
                            { label: 'overline', value: 'overline' },
                            { label: 'None', value: 'none' },

                        ]}
                        value={attributes.counter_title_decoration}
                        onChange={(new_val) => {
                            setAttributes({ counter_title_decoration: new_val })
                        }}
                    />
                    <SelectControl
                        label="Style"
                        options={[
                            { label: 'Default', value: 'none' },
                            { label: 'Normal', value: 'normal' },
                            { label: 'Italic', value: 'italic' },
                            { label: 'Oblique', value: 'oblique' },
                        ]}
                        value={attributes.title_font_style}
                        onChange={(new_val) => {
                            setAttributes({ title_font_style: new_val })
                        }}
                    />

                    <PanelRow>
                        <p>Typography</p>

                        <div>
                            <Button id="px_title_case" onClick={pxTitleCase} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="em_title_case" onClick={emTitleCase} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                            <Button id="rem_title_case" onClick={remTitleCase} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>rem</Button>
                            <Button id="vw_title_case" onClick={vwTitleCase} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vw</Button>
                        </div>
                    </PanelRow>
                    <RangeControl
                        label="Title Font Size"
                        min={0}
                        max={attributes.title_font_range_controller}
                        step={1}
                        initialPosition={26}
                        value={attributes.counter_title_size}
                        onChange={(new_val) => {
                            setAttributes({ counter_title_size: new_val })
                        }}
                    />
                    <PanelRow>
                        <p>Typography</p>

                        <div>
                            <Button id="title_px_lineh" onClick={titlePxLh} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="title_em_lineh" onClick={titleEmLh} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                        </div>
                    </PanelRow>
                    <RangeControl
                        label="Title Line Height "
                        min={0}
                        max={attributes.title_line_range_controller}
                        step={0.1}
                        initialPosition={1.5}
                        value={attributes.counter_title_height}
                        onChange={(new_val) => {
                            setAttributes({ counter_title_height: new_val })
                        }}
                    />
                    <RangeControl
                        label="Letter Spacing (px)"
                        min={0}
                        max={10}
                        step={0.1}
                        initialPosition={0}
                        value={attributes.title_letter_spacing_counter}
                        onChange={(new_val) => {
                            setAttributes({ title_letter_spacing_counter: new_val })
                        }}
                    />


                    <PanelRow>
                        <p>Text Shadow</p>
                        <div>
                            <Button onClick={titleReset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                            <Button onClick={titleToggle} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} /></span></Button>
                        </div>
                    </PanelRow>
                    <Card id="title_toggle" style={{ display: "none" }}>
                        <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>

                            <RangeControl
                                label="Blur"
                                min={0}
                                max={100}
                                step={0.1}
                                initialPosition={10}
                                value={attributes.counter_title_shadow_blur}
                                onChange={(new_val) => {
                                    setAttributes({ counter_title_shadow_blur: new_val })
                                    console.log("Bur")
                                }}
                            />
                            <RangeControl
                                label="horizontal"
                                min={-100}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={attributes.counter_title_shadow_horizontal}
                                onChange={(new_val) => {
                                    setAttributes({ counter_title_shadow_horizontal: new_val })
                                    console.log("horitzental")
                                }}
                            />

                            <RangeControl
                                label="Vertical"
                                min={-100}
                                max={100}
                                step={0.1}
                                initialPosition={0}
                                value={attributes.counter_title_shadow_vertical}
                                onChange={(new_val) => {
                                    setAttributes({ counter_title_shadow_vertical: new_val })
                                    console.log("vertical")
                                }}
                            />

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <p> <span>Title Shadow Color</span>
                                    <ColorIndicator
                                        style={{ backgroundColor: attributes.counter_title_shadow_color }} />
                                </p>
                                <Dashicon icon="image-rotate" onClick={clearTitleShadowColor} />
                            </div>
                            <ColorPalette
                                clearable={false}
                                colors={color_palette_list}
                                onChange={(new_val) => {
                                    setAttributes({ counter_title_shadow_color: new_val })

                                }}
                                value={attributes.counter_title_shadow_color}
                            />
                        </CardBody>
                    </Card>

                </PanelBody>

            </InspectorControls>

            <div className={`gb-counter-main ${props.className}`} style={{ textAlign: attributes.counter_align }}>
                <div style={styles.counter_style}>
                    <span>{`${attributes.count_prefix} `}</span>
                    <span className="counter"
                        data-counter-start={attributes.count_start}
                        data-counter-duration={attributes.count_animation_duration}
                        data-counter-end={attributes.count_end}>0</span>
                    <span>{` ${attributes.count_suffix}`}</span>
                </div>
                <RichText
                    style={styles.title_style}
                    tagName="P"
                    value={attributes.count_title}
                    onChange={(count_title) => setAttributes({ count_title })}
                    placeholder={__('Cool Number')}
                />

            </div>
        </React.Fragment >);
    },

    save: (props) => {
        return (null)
    }
})
